// import RulePack from './RulePack';

export default {
  priority: 20,
  path: "packet",
  permissions: ["Salary/TaxAndInsuranceMenu"], // component: RulePack,
  component: load(() =>
    import(/* webpackChunkName: "Request-pattern-RulePack" */ "./RulePack")
  ),
  name: "جدول مالیات و بیمه",
  icon: "content-paste",
  drawer: true,
};
